export default "__VITE_ASSET__1ef4ba6b__"